// Mock data for NestTrack Care Connections

const IMG = {
  sarah: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMHBvcnRyYWl0JTIwc21pbGluZ3xlbnwwfHx8fDE3ODgwMzY3NjV8MA&ixlib=rb-4.1.0&q=85",
  marcus: "https://images.unsplash.com/photo-1614023342667-6f060e9d1e04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fDE3ODgwMzY3NjV8MA&ixlib=rb-4.1.0&q=85",
  aisha: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjYXJlZ2l2ZXIlMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzg4MDM3NjMyfDA&ixlib=rb-4.1.0&q=85",
  david: "https://images.unsplash.com/photo-1622253694238-3b22139576c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjYXJlZ2l2ZXIlMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzg4MDM3NjMyfDA&ixlib=rb-4.1.0&q=85",
  grace: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMHBvcnRyYWl0JTIwc21pbGluZ3xlbnwwfHx8fDE3ODgwMzY3NjV8MA&ixlib=rb-4.1.0&q=85",
  tom: "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fDE3ODgwMzY3NjV8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICE_TYPES = [
  "Childcare",
  "Respite Care",
  "Babysitting",
  "Personal Care",
  "Special Needs Support",
  "After-School Care",
  "Evening Care",
  "Weekend Care",
  "Overnight Care",
  "Senior/Adult Companion Care",
  "Transportation Assistance",
  "Other",
];

// Demo view-switcher identities. Admin access is gated to admin role:
// Michael Winston (owner) + any profile invited with the admin role.
export const VIEW_USERS = {
  family: { key: "family", name: "Jennifer M.", email: "jennifer.m@example.com", role: "family" },
  caregiver: { key: "caregiver", name: "Sarah Johnson", email: "sarah.j.care@example.com", role: "caregiver", caregiverId: "cg_1" },
  admin: { key: "admin", name: "Michael Winston", email: "michaelwinston8219@gmail.com", role: "admin" },
};

export const MOCK_CAREGIVERS = [
  {
    id: "cg_1",
    name: "Sarah Johnson",
    title: "Professional Caregiver",
    photo: IMG.sarah,
    bio: "Former daycare lead teacher with a passion for respite and evening care. Patient, dependable, and great with toddlers through school-age kids.",
    services: ["Respite Care", "Childcare", "Babysitting", "Evening Care", "Weekend Care", "Special Needs Support"],
    categories: ["Respite Worker", "Babysitter"],
    yearsExperience: 7,
    credentials: [
      { type: "Identity", verified: true },
      { type: "Background Check", verified: true },
      { type: "CPR", verified: true },
      { type: "First Aid", verified: true },
      { type: "Respite Certification", verified: true },
    ],
    hourlyRate: 25,
    rateMax: 30,
    city: "Sacramento, CA",
    zip: "95814",
    radiusMiles: 15,
    distanceMiles: 4.3,
    rating: 4.9,
    reviewCount: 24,
    available: true,
    featured: true,
    status: "active",
    availability: { Monday: "4 PM–10 PM", Tuesday: "4 PM–10 PM", Wednesday: "4 PM–10 PM", Saturday: "All Day" },
  },
  {
    id: "cg_2",
    name: "Marcus Williams",
    title: "Personal Care & Companion Specialist",
    photo: IMG.marcus,
    bio: "Certified nursing assistant focused on personal care, companionship, and respite support for children and adults.",
    services: ["Personal Care", "Senior/Adult Companion Care", "Respite Care"],
    categories: ["Personal Caregiver", "Companion", "CNA"],
    yearsExperience: 8,
    credentials: [
      { type: "Identity", verified: true },
      { type: "Background Check", verified: true },
      { type: "CNA", verified: true },
      { type: "CPR", verified: true },
      { type: "First Aid", verified: true },
    ],
    hourlyRate: 22,
    rateMax: 26,
    city: "Sacramento, CA",
    zip: "95816",
    radiusMiles: 25,
    distanceMiles: 6.1,
    rating: 5.0,
    reviewCount: 17,
    available: true,
    featured: false,
    status: "active",
    availability: { Monday: "8 AM–6 PM", Thursday: "8 AM–6 PM", Friday: "8 AM–2 PM", Sunday: "All Day" },
  },
  {
    id: "cg_3",
    name: "Aisha Bello",
    title: "Special Needs Caregiver",
    photo: IMG.aisha,
    bio: "Behavioral support background with 5 years of experience in special needs childcare and after-school programs.",
    services: ["Special Needs Support", "Childcare", "After-School Care"],
    categories: ["Special Needs Caregiver", "Childcare Provider"],
    yearsExperience: 5,
    credentials: [
      { type: "Identity", verified: true },
      { type: "Background Check", verified: true },
      { type: "CPR", verified: true },
      { type: "First Aid", verified: true },
    ],
    hourlyRate: 28,
    rateMax: 32,
    city: "Sacramento, CA",
    zip: "95811",
    radiusMiles: 10,
    distanceMiles: 2.8,
    rating: 4.8,
    reviewCount: 31,
    available: true,
    featured: true,
    status: "active",
    availability: { Monday: "2 PM–8 PM", Wednesday: "2 PM–8 PM", Friday: "2 PM–8 PM" },
  },
  {
    id: "cg_4",
    name: "David Chen",
    title: "Companion & Transportation Provider",
    photo: IMG.david,
    bio: "Reliable companion care and safe transportation for appointments, activities, and outings.",
    services: ["Senior/Adult Companion Care", "Transportation Assistance", "Personal Care"],
    categories: ["Companion", "Transportation Provider", "Senior Caregiver"],
    yearsExperience: 6,
    credentials: [
      { type: "Identity", verified: true },
      { type: "Background Check", verified: true },
      { type: "First Aid", verified: true },
    ],
    hourlyRate: 20,
    rateMax: 24,
    city: "West Sacramento, CA",
    zip: "95691",
    radiusMiles: 25,
    distanceMiles: 9.4,
    rating: 4.7,
    reviewCount: 12,
    available: true,
    featured: false,
    status: "active",
    availability: { Tuesday: "9 AM–5 PM", Thursday: "9 AM–5 PM", Saturday: "9 AM–5 PM" },
  },
  {
    id: "cg_5",
    name: "Grace Okafor",
    title: "Overnight & Newborn Care Specialist",
    photo: IMG.grace,
    bio: "Overnight care, newborn support, and weekend coverage. 10 years of professional childcare experience.",
    services: ["Overnight Care", "Weekend Care", "Childcare", "Babysitting"],
    categories: ["Nanny", "Childcare Provider"],
    yearsExperience: 10,
    credentials: [
      { type: "Identity", verified: true },
      { type: "Background Check", verified: true },
      { type: "CPR", verified: true },
      { type: "First Aid", verified: true },
      { type: "Childcare Certification", verified: true },
    ],
    hourlyRate: 30,
    rateMax: 35,
    city: "Sacramento, CA",
    zip: "95818",
    radiusMiles: 15,
    distanceMiles: 5.2,
    rating: 4.9,
    reviewCount: 40,
    available: false,
    featured: false,
    status: "active",
    availability: { Friday: "Overnight", Saturday: "Overnight", Sunday: "Overnight" },
  },
  {
    id: "cg_6",
    name: "Tom Reilly",
    title: "Evening Babysitter",
    photo: IMG.tom,
    bio: "College student and part-time babysitter available evenings for school-age children.",
    services: ["Babysitting", "Evening Care"],
    categories: ["Babysitter"],
    yearsExperience: 3,
    credentials: [
      { type: "Identity", verified: true },
      { type: "Background Check", verified: false },
      { type: "CPR", verified: false },
    ],
    hourlyRate: 18,
    rateMax: 20,
    city: "Sacramento, CA",
    zip: "95825",
    radiusMiles: 15,
    distanceMiles: 12.0,
    rating: 4.6,
    reviewCount: 8,
    available: true,
    featured: false,
    status: "pending",
    availability: { Monday: "6 PM–11 PM", Tuesday: "6 PM–11 PM", Thursday: "6 PM–11 PM" },
  },
];

export const MOCK_REQUESTS = [
  {
    id: "req_1",
    familyKey: "family",
    familyName: "Jennifer M.",
    caregiverId: "cg_1",
    service: "Respite Care",
    date: "2026-08-22",
    startTime: "6:00 PM",
    endTime: "11:00 PM",
    location: "8 miles from you",
    notes: "Looking for someone experienced with children and comfortable providing evening supervision.",
    status: "sent",
  },
  {
    id: "req_2",
    familyKey: "family",
    familyName: "Jennifer M.",
    caregiverId: "cg_2",
    service: "Personal Care",
    date: "2026-07-30",
    startTime: "9:00 AM",
    endTime: "1:00 PM",
    location: "6 miles from you",
    notes: "Morning companion care for my father.",
    status: "completed",
  },
];

export const MOCK_CONNECTIONS = [
  { id: "con_1", caregiverId: "cg_1", familyKey: "family", familyName: "Jennifer M.", connectedDate: "Aug 15, 2026", status: "connected" },
  { id: "con_2", caregiverId: "cg_2", familyKey: "family", familyName: "Jennifer M.", connectedDate: "Jul 30, 2026", status: "connected" },
];

export const MOCK_MESSAGES = {
  cg_1: [
    { id: "m1", sender: "me", text: "Hi Sarah, are you available Saturday from 6–11?", time: "10:02 AM" },
    { id: "m2", sender: "them", text: "Yes, I am.", time: "10:15 AM" },
    { id: "m3", sender: "me", text: "Great. I'd like to discuss the details.", time: "10:18 AM" },
  ],
  cg_2: [{ id: "m4", sender: "them", text: "Happy to help again anytime — just send a request.", time: "Jul 30" }],
};

export const MOCK_REVIEWS = [
  { id: "rev_1", caregiverId: "cg_1", reviewer: "Jennifer M.", rating: 5, text: "Very dependable and great with my child.", date: "Aug 16, 2026", wouldReconnect: true },
  { id: "rev_2", caregiverId: "cg_1", reviewer: "The Alvarez Family", rating: 5, text: "Sarah handled bedtime like a pro. Our kids ask for her by name.", date: "Aug 2, 2026", wouldReconnect: true },
  { id: "rev_3", caregiverId: "cg_2", reviewer: "Jennifer M.", rating: 5, text: "Kind, patient, and professional companion care.", date: "Jul 31, 2026", wouldReconnect: true },
];

export const MOCK_CATEGORIES = [
  "Respite Worker",
  "Personal Caregiver",
  "Babysitter",
  "Nanny",
  "Companion",
  "CNA",
  "Childcare Provider",
  "Special Needs Caregiver",
  "Transportation Provider",
  "Senior Caregiver",
];

export const MOCK_REPORTS = [
  { id: "rep_1", caregiverId: "cg_6", reason: "Profile information appears inaccurate.", status: "open", date: "Aug 12, 2026" },
];

export const VERIFICATION_DISCLAIMER =
  "Verification does not constitute an endorsement, guarantee of safety, employment relationship, or determination of professional suitability. Families should independently evaluate caregivers before hiring.";

export const FEATURED_DISCLAIMER =
  "Featured placement does not indicate NestTrack endorsement or superior qualification.";
